<div class="form-container">
  
  <div class="subform-container">
    <div class="title-text">{{getString('changeEmailText')}}</div>
    <div class="form-field">
      <app-input-field [type]="'email'" [placeholder]="getString('newEmailAddress')" [autocomplete]="'email'" [name]="'email'" (valueChanged)="onEmailChange($event)"></app-input-field>
    </div>

    <div class="form-field">
      <app-input-field [type]="'email'" [placeholder]="getString('confirmNewEmailAddress')" [autocomplete]="'email'" [name]="'email-confirm'" (valueChanged)="onConfirmEmailChange($event)"></app-input-field>
    </div>

    <div class="form-field">
      <button type="button" class="blue-button" (click)="changeEmail()">{{getString('change')}}</button>
    </div>

    <div class="message-container">
        <div class="red-text" *ngIf="invalidEmail">{{getString('invalidEmail')}}</div>
        <div class="green-text" *ngIf="emailChangeSuccess">{{getString('success')}}!</div>
        <div class="red-text" *ngIf="serverError">{{serverMessage}}</div>
    </div>

  </div>

  <div class="subform-container">
    <div class="title-text">{{getString('changePasswordText')}}</div> 
    <div class="form-field">
      <app-input-field [type]="'password'" [placeholder]="getString('password')" [autocomplete]="'new-password'" [name]="'password'" (valueChanged)="onPasswordChange($event)"></app-input-field>
    </div>

    <div class="form-field">
      <app-input-field [type]="'password'" [placeholder]="getString('confirmPassword')" [autocomplete]="'new-password'" [name]="'password-confirm'" (valueChanged)="onConfirmPasswordChange($event)"></app-input-field>
    </div>

    <div class="form-field">
      <button type="button" class="blue-button" (click)="changePassword()">{{getString('change')}}</button>
    </div>

    <div class="message-container">
        <div class="red-text" *ngIf="invalidPassword">{{getString('invalidPassword')}}</div>
        <div class="green-text" *ngIf="passwordChangeSuccess">{{getString('success')}}!</div>
    </div>
  </div>

</div>